import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map, Set } from 'immutable';

import { TaskItemEntity } from './app-task-item.entity';

export interface ITaskListExtra extends IListColumnConfig<TaskItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface ITaskListEntity extends IListAttrs<TaskItemEntity> {
	availableColumns: Map<string, ITaskListExtra>;
}

const entityDefaults: ITaskListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class TaskListEntity
	implements ITaskListEntity, IListOperations<TaskListEntity, TaskItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(availableCols: Array<ITaskListExtra>): TaskListEntity {
		const inst = new TaskListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, ITaskListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<string, IListColumnConfig<TaskItemEntity>> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, TaskItemEntity>): TaskListEntity {
		return produce(this, (draft: TaskListEntity) => {
			draft.elements = elems;
		});
	}

	public extractTypes(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, taskItem) => {
			if (taskItem.taskType && taskItem.taskType?.value) {
				acc = acc.add(taskItem.taskType.value);
			}
			return acc;
		}, Set<string>(startValues));
	}
}
